import React from 'react'
import { Button } from 'spa/member/components/v2/Button'
import { useIsMobile } from 'spa/member/hooks/v2/useScreenSize'
import styles from './Inquiry.module.scss'

export const StyledInquiry: React.FC = () => {
  const isMobile = useIsMobile()

  return (
    <section className={`flex flex-col items-center gap-M px-M py-XL border-t-1 border-member-gray-20 text-center
      tablet:px-3XL tablet:py-XL desktop:p-4XL desktop:border-t-0 desktop:border-l-1 ${styles.inquiry}`}>
      <div className="text-S tablet:text-M">お気軽にお問い合わせください。</div>
      <a href="/inquiry">
        <Button buttonType={isMobile ? 'SMALL' : 'DEFAULT'}>お問い合わせをする</Button>
      </a>
      <p className="text-XS">
        お問い合わせの前に<a href="/faq" className={`text-member-green-100 ${styles.faqLink}`}>よくある質問</a>をご覧ください。
        <br />
        現在お電話での受付を停止しております。
      </p>
    </section>
  )
}
